import axios from 'axios'
import toast from 'react-hot-toast'
const getBimlinks = async options => {
  try {
    const response = await axios.get('/api/bimlinks', {
      params: {
        ...options,
      },
    })

    const data = response.data
    console.log('dataaaa', data)

    // Calcular nextPage si no lo devuelve el servidor
    // const nextPage =
    //   data.data && data.data.total > (options.page || 1) * (options.limit || 13)
    //     ? (options.page || 1) + 1
    //     : undefined

    // Normalizar la respuesta
    return data
    // return {
    //   data: {
    //     data: data.data.data || [], // Los datos reales de los bimlinks
    //     total: data.data.total || 0, // Total de elementos
    //     totalPages:
    //       data.data.totalPages ||
    //       Math.ceil((data.data.total || 0) / (options.limit || 13)),
    //     nextPage: nextPage, // Siguiente página o undefined si no hay más
    //   },
    // }
  } catch (error) {
    console.error('Error fetching bimlinks:', error)
    throw new Error(
      `Failed to fetch bimlinks: ${error.message || 'Unknown error'}`
    )
  }
}

const getAllBimLinks = async codes => {
  const filterCodes = codes.filter(code => code !== '')
  const bimLinks = await axios.post('/api/bimlinks/bycodes', filterCodes)
  return bimLinks?.data
}

const createBimlink = async bimlink => {

  try {
    const newBimlink = await axios.post('/api/bimlinks', bimlink)
    return newBimlink?.data
  } catch (e) {
    console.log(e)
  }
}

const updateBimlink = async bimlink => {
  const { id, ...rest } = bimlink
  try {
    const updatedBimlink = await axios.patch(`/api/bimlinks/${id}`, { rest })
    return updatedBimlink?.data
  } catch (e) {
    console.log(e)
  }
}

const deleteBimlink = async id => {
  try {
    return await axios.delete(`/api/bimlinks/${id}`)
  } catch (e) {
    throw e
  }
}

const getOneBimLink = async id => {
  try {
    const bimlink = await axios.get(`/api/bimlinks/${id}`)
    return bimlink
  } catch (e) {
    toast.error('Error al cargar bimlink. Por favor, vuélvelo a intentarlo')
    throw new Error(e)
  }
}

export {
  getAllBimLinks,
  createBimlink,
  updateBimlink,
  getBimlinks,
  deleteBimlink,
  getOneBimLink,
}
